const value = Object.freeze({
  Borrador: 1,
  Sometido: 2,
  NoAmeritaAccion: 3,
  EnProceso: 4,
  Extendido: 5,
  Atendido: 6,
});

export const actionPlanStatusNames = Object.freeze({
  [value.Borrador]: 'Borrador',
  [value.Sometido]: 'Sometido',
  [value.NoAmeritaAccion]: 'No Amerita Acción',
  [value.EnProceso]: 'En Proceso',
  [value.Extendido]: 'Extendido',
  [value.Atendido]: 'Atendido',
});

export default value;
